import { render, staticRenderFns } from "./access-apply.vue?vue&type=template&id=6cb39e46&scoped=true&lang=pug&"
import script from "./access-apply.vue?vue&type=script&lang=js&"
export * from "./access-apply.vue?vue&type=script&lang=js&"
import style0 from "./access-apply.vue?vue&type=style&index=0&id=6cb39e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb39e46",
  null
  
)

export default component.exports